/* eslint-disable import/prefer-default-export */

import {
  GET_TRANSCODING_JOBS,
  GET_TRANSCODING_JOBS_SUCCESS,
  GET_TRANSCODING_JOBS_FAIL,
  RESET_TRANSCODING_JOBS,
  UPDATE_TRANSCODING_JOB,
} from '../constants';
import { buildQuery } from '../helpers';

export function getTranscodingJobs(
  params = {
    page: 1,
    perPage: 20,
  },
) {
  const query = buildQuery(params);

  return {
    types: [
      GET_TRANSCODING_JOBS,
      GET_TRANSCODING_JOBS_SUCCESS,
      GET_TRANSCODING_JOBS_FAIL,
    ],
    promise: fetch => fetch(`/api/transcoding_jobs?${query}`),
  };
}

export function updateJob(job) {
  return {
    type: UPDATE_TRANSCODING_JOB,
    job,
  };
}

export function resetTranscodingJobs() {
  return {
    type: RESET_TRANSCODING_JOBS,
  };
}
